import { render, staticRenderFns } from "./Publicado.vue?vue&type=template&id=4e24b0f0&"
import script from "./Publicado.vue?vue&type=script&lang=js&"
export * from "./Publicado.vue?vue&type=script&lang=js&"
import style0 from "./Publicado.vue?vue&type=style&index=0&id=4e24b0f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports